import React, { useEffect, useState } from "react";
import { Modal } from "../Modal";
import "../../styles/Authentication.scss";
import { useLabelsContext } from "../../context/LabelsContext";
import { AuthSuccess } from "./AuthSuccess";
import { useUserContext } from "../../context/UserContext";
import { Popup } from "../Popup";
import Greeting from "../Greeting";
import { isMobile } from "react-device-detect";
import { OtpForm } from "./OtpForm";
import { LoginForm } from "./LoginForm";
import { useAuthContext } from "../../context/AuthContext";
import { AUTH_STEPS } from "../../models/auth-steps";
import { ProfileRecovery } from "./ProfileRecovery";
import { emitEvent, PLUGIN_EVENTS } from "../../utils/pluginEvents";

type AuthenticationProps = {
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Authentication: React.FC<AuthenticationProps> = ({
	setIsModalOpen,
}) => {
	const { labels } = useLabelsContext();
	const { user, setUser } = useUserContext();
	const { authStep, setAuthStep, initOtpMethod, interestedUser } =
		useAuthContext();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const onClose = (): void => {
		setIsModalOpen(false);

		if (
			authStep === AUTH_STEPS.LOGGED_IN ||
			authStep === AUTH_STEPS.SUCCESS
		)
			return;

		initAuth();
	};

	const handleAuthFlow = (): void => {
		switch (authStep) {
			case AUTH_STEPS.LOGIN:
				setAuthStep(AUTH_STEPS.OTP);
				break;
			case AUTH_STEPS.OTP:
				setAuthStep(AUTH_STEPS.SUCCESS);
				break;
			default:
				break;
		}
	};

	const initAuth = (): void => {
		setAuthStep(AUTH_STEPS.LOGIN);
		setUser(null);
		initOtpMethod();
	};

	useEffect(() => {
		if (user?.LoggedIn) setAuthStep(AUTH_STEPS.LOGGED_IN);
	}, []);

	useEffect(() => {
		if (interestedUser?.MissingRequiredField) {
			setAuthStep(AUTH_STEPS.LOGIN);
		}
	}, [interestedUser]);

	useEffect(() => {
		if (authStep === AUTH_STEPS.SUCCESS) {
			emitEvent(PLUGIN_EVENTS.LOGIN_SUCCESS, user);
		}
	}, [authStep, user]);

	return (
		<>
			{authStep === AUTH_STEPS.LOGGED_IN ? (
				!isMobile && (
					<Popup
						isOpen={true}
						onClose={onClose}
						children={<Greeting closeModal={onClose} />}
					/>
				)
			) : (
				<Modal
					onClose={onClose}
					backBtnLabel={
						(authStep === AUTH_STEPS.OTP &&
							labels?.["BackLabel"]) ||
						""
					}
					onBack={() =>
						authStep === AUTH_STEPS.OTP &&
						setAuthStep(AUTH_STEPS.LOGIN)
					}
				>
					{authStep === AUTH_STEPS.LOGIN && (
						<LoginForm
							handleAuthFlow={handleAuthFlow}
							setIsModalOpen={setIsModalOpen}
							isLoading={isLoading}
							setIsLoading={setIsLoading}
						/>
					)}
					{authStep === AUTH_STEPS.OTP && (
						<OtpForm handleAuthFlow={handleAuthFlow} />
					)}
					{authStep === AUTH_STEPS.SUCCESS && (
						<AuthSuccess setIsModalOpen={setIsModalOpen} />
					)}
					{authStep === AUTH_STEPS.PROFILE_RECOVERY && (
						<ProfileRecovery />
					)}
				</Modal>
			)}
		</>
	);
};
